import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { ILocation } from '@nimbus-global/features/shared/services/api/i-location.models';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';
import { IEnvironmentService } from '@nimbus-library/features/configuration/i-environment.service';
import { BaseLocationSelector } from '../../base-location-selector';
import { IGeoLocationService } from '../../services/i-geo-location.service';

@Component({
  standalone: false,
  selector: 'nimbus-global-location-selector-modal',
  templateUrl: './location-selector-modal.component.html',
  styleUrls: ['./location-selector-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationSelectorModalComponent extends BaseLocationSelector implements OnInit, OnDestroy {
  @HostBinding('class')
  public class: string = 'nimbus-material-popup location-selector-popup';

  public selectedLocation: ILocation;

  private initialLocation: ILocation;

  public get isApplicationAdmin(): boolean {
    return this.environmentService.isApplicationAdmin;
  }

  public constructor(
    private modal: MatDialogRef<any>,
    private readonly environmentService: IEnvironmentService,
    store: Store,
    geoLocationService: IGeoLocationService,
    permissionManagerService: IPermissionManagerService,
  ) {
    super(store, geoLocationService, permissionManagerService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
  }

  public cancel(): void {
    this.modal.close(true);
  }

  public apply(): void {
    const selectedLocation: ILocation = this.selectedLocation || this.initialLocation;

    if (this.initialLocation && selectedLocation.location === this.initialLocation.location) {
      this.cancel();
    } else {
      this.getLocationService.redirectToLocation(selectedLocation, true);
    }
  }

  public onLocationSelected(location: ILocation): void {
    this.selectedLocation = location;
  }

  public setInitialLocation(location: ILocation): void {
    this.initialLocation = location;
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
